
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { getStoreList, StoreListDTO } from '@/api/industryMall'
@Component
export default class storeList extends Vue {
  @Prop({ default: '' }) keyword!: string
  @Getter partnerCompanyId!: string
  refreshing = false
  loading = false
  finished = false

  params = {
    keyword: '',
    partnerCompanyId: '',
    pageSize: 10,
    pageIndex: 1
  }
  storeList: StoreListDTO[] = []
  isLoading = false
  listScrollTop = 0

  @Watch('keyword', { immediate: true })
  handleKeyword(newVal: string) {
    this.params.partnerCompanyId = this.partnerCompanyId
    this.params.keyword = newVal
    this.params.pageIndex = 1
    this.storeList = []
    this.getStoreList()
  }

  created() {
    this.params.keyword = this.keyword
    this.params.partnerCompanyId = this.partnerCompanyId
    this.getStoreList()
  }

  handleScroll (event: any) {
    this.listScrollTop = event.target.scrollTop
  }

  activated() {
    document.querySelector('.store-refresh') && document.querySelector('.store-refresh').scrollTo(0, this.listScrollTop)
  }

  onRefresh() {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getStoreList()
  }

  onLoad() {
    this.params.pageIndex++
    this.getStoreList()
  }

  toGoodDetail(item: any) {
    this.$router.push({
      path: '/goodsMallDetail',
      query: {
        goodsId: item.goodsId,
        storeId: item.storeId
      }
    })
  }

  getStoreList() {
    getStoreList({ ...this.params })
      .then((res) => {
        if (this.refreshing) {
          this.storeList = []
        }
        this.storeList = this.storeList.concat(res.data.records)
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
      .catch(() => {
        this.finished = true
      })
      .finally(() => {
        this.isLoading = true
        this.loading = false
        this.refreshing = false
      })
  }

  goStore(store) {
    this.$router.push({
      path: '/shopMallInfo',
      query: {
        storeId: store.storeId
      }
    })
  }
}
